import { ReactComponent as Level1Icon } from "../icons/level1.svg";
import { ReactComponent as Level10Icon } from "../icons/level10.svg";
import { ReactComponent as Level11Icon } from "../icons/level11.svg";
import { ReactComponent as Level12Icon } from "../icons/level12.svg";
import { ReactComponent as Level13Icon } from "../icons/level13.svg";
import { ReactComponent as Level14Icon } from "../icons/level14.svg";
import { ReactComponent as Level15Icon } from "../icons/level15.svg";
import { ReactComponent as Level2Icon } from "../icons/level2.svg";
import { ReactComponent as Level3Icon } from "../icons/level3.svg";
import { ReactComponent as Level4Icon } from "../icons/level4.svg";
import { ReactComponent as Level5Icon } from "../icons/level5.svg";
import { ReactComponent as Level6Icon } from "../icons/level6.svg";
import { ReactComponent as Level7Icon } from "../icons/level7.svg";
import { ReactComponent as Level8Icon } from "../icons/level8.svg";
import { ReactComponent as Level9Icon } from "../icons/level9.svg";

export function pickLevelIcon(level: number) {
  switch (level) {
    case 1:
      return Level1Icon;
    case 2:
      return Level2Icon;
    case 3:
      return Level3Icon;
    case 4:
      return Level4Icon;
    case 5:
      return Level5Icon;
    case 6:
      return Level6Icon;
    case 7:
      return Level7Icon;
    case 8:
      return Level8Icon;
    case 9:
      return Level9Icon;
    case 10:
      return Level10Icon;
    case 11:
      return Level11Icon;
    case 12:
      return Level12Icon;
    case 13:
      return Level13Icon;
    case 14:
      return Level14Icon;
    case 15:
      return Level15Icon;
    default:
      return Level15Icon;
  }
}
